// extracted by mini-css-extract-plugin
export default {"copy":"SMLCopyLinkButton_copy__bqM5Z","copied":"SMLCopyLinkButton_copied__a6FR8"};